<api-call-gate [apiCall]="coilService.getSystemCoils">
  <ng-template #lastSuccessfulData>
    <sh-text color="primary" size="header-2" class="flex local-coil"
      >Local Coils
      <ng-container *ngIf="reversedDates$ | async; let dateRange">
        <span>
          {{ dateRange.firstDate | localizedDate }} to
          {{ dateRange.lastDate | localizedDate }}
        </span>
      </ng-container>
    </sh-text>

    <section class="coil-detail-container">
      <app-coil-detail
        *ngFor="let coil of systemCoils$ | async"
        [coil]="coil"
        [currentlyExpandedCoil]="expandedCoilSerialNumber"
        [toggleCoilExpansion]="toggleCoilExpansion.bind(this)"
      ></app-coil-detail>
    </section>
  </ng-template>

  <ng-template #error let-error>
    <app-no-data-icon
      [iconName]="'no-findings'"
      error="{{ 'label.noDataCoil' | translate }}"
    ></app-no-data-icon>
  </ng-template>
</api-call-gate>
